(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ActivationSuccessController', ActivationSuccessController);

  /** @ngInject */
  function ActivationSuccessController() {
    // var vm = this;

  }
})();
